import React from 'react';
import PropTypes from 'prop-types';
import { gettext } from '@eb/i18n';
import classNames from 'classnames';

import { CheckChunky } from '@eb/eds-iconography';
import { Button } from '@eb/eds-button';

import NotificationScreen from '../NotificationScreen';

import './PasswordlessEmailStatus.scss';

const PasswordlessEmailStatus = ({ email, onClick }) => {
    const componentClasses = classNames(
        'eds-l-mar-vert-14 passwordless-email-status',
    );
    const iconProps = {
        iconColor: 'ui-700',
        iconType: <CheckChunky />,
    };
    const headerText = gettext('Check your email');
    let subtitleText = gettext(
        'We sent your login link to your email address.',
    );

    //Need to conditionally check if the email is present and update copy accordingly
    //in case the user refreshes the notification page and we lose the email from state.
    if (email) {
        subtitleText = (
            <p>
                {gettext('We sent your login link to ')}
                <strong>{email}</strong>
            </p>
        );
    }

    return (
        <div className={componentClasses}>
            <NotificationScreen {...iconProps} headerText={headerText} />

            <div
                className="eds-text--center es-text-bm eds-text-bm eds-l-mar-hor-3 eds-l-mar-bot-8"
                data-testid="page-header-subtitle"
            >
                {subtitleText}
            </div>
            <p className="eds-text--center eds-text-color--grey-600 eds-text-bm eds-l-mar-hor-3">
                {gettext('For your security, the link expires in 2 hours')}
            </p>
            <div className="eds-l-pad-top-8 eds-align--center">
                <Button
                    type="button"
                    style="link"
                    onClick={onClick}
                    data-testid="passwordless-ok-button"
                    __containerClassName="passwordless-form__button--grey"
                >
                    {gettext('OK')}
                </Button>
            </div>
        </div>
    );
};

PasswordlessEmailStatus.propTypes = {
    email: PropTypes.string,
};

export default PasswordlessEmailStatus;
